module.exports = __webpack_public_path__ + "img/source3.44e8b790.png";